import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";
import { SPORTS as DEF_SPORTS, TEAMS as DEF_TEAMS } from "@/constants/categories";

const CategoriesContext = createContext(null);

export function CategoriesProvider({ children }) {
  const [sports, setSports] = useState(DEF_SPORTS);
  const [teams, setTeams] = useState(DEF_TEAMS);

  const refresh = useCallback(() => {
    return api
      .get("/categories")
      .then(({ data }) => {
        if (data.sports) setSports(data.sports);
        if (data.teams) setTeams(data.teams);
      })
      .catch(() => {});
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const sportLabel = (id) => sports.find((s) => s.id === id)?.label || id;
  const teamLabel = (id) => teams.find((t) => t.id === id)?.label || id;
  const sportColor = (id) => sports.find((s) => s.id === id)?.color || "#A1A1AA";

  return (
    <CategoriesContext.Provider value={{ sports, teams, sportLabel, teamLabel, sportColor, refresh }}>
      {children}
    </CategoriesContext.Provider>
  );
}

export const useCategories = () => useContext(CategoriesContext);
